export default "__VITE_ASSET__BxA$M4Vx__"